/**
 * ------ maintenance history ------
 *
 * Reviewed by Alan Yang on 2020.1.2
 * The home page integrates all the components as below except auditlog and settings, so they can't be
 * moved from home module for lazy loading due to the design.
 * As for auditlog, it's too small,no need to do it; and for settings, the below 3 dialogs have to be put into
 * home.component.html, or their popup dialog can't cover the left navigation menu.
 *      <email-digest-dialog></email-digest-dialog>
        <tam-manage-relationship-dialog></tam-manage-relationship-dialog>
        <email-digest-preview-box></email-digest-preview-box>
    In conlusion, we can't do lazy loading in home module until desgin change.
 */
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from './home.component';
import { HomeGuard } from './home.guard';
import { ContactComponent } from '../contact/contact.component';
import { ThreadViewComponent } from '../thread/thread-view/thread-view.component';
import { AuditLogComponent } from '../../components/audit-log/audit-log.component';
import { ResearchWrapperComponent } from '../research/research-wrapper/research-wrapper.component';
import { HomeScreenComponent } from '../home-screen/home-screen.component';
import { DashboardEditorComponent } from '../dashboard/dashboard-editor/dashboard-editor.component';
import { DashboardViewerWrapperComponent } from '../dashboard/dashboard-viewer-wrapper/dashboard-viewer-wrapper.component';
import { DataImportComponent } from '../settings/data-import.component';
import { GlobalSearchComponent } from '../global-search/global-search.component';
import { ContactListComponent } from '../contact-list/contact-list.component';
import { EmailDigestEditorComponent } from '../email-digest/email-digest-editor.component';
import { FileViewComponent } from '../file-view/file-view.component';
import { EntityListComponent } from '../entity-list/entity-list.component';
import { DataImportGuard } from '../settings/data-import.guard';
import { DashboardGuard } from '../dashboard/dashboard.guard';
import { EmailDigestGuard } from '../email-digest/email-digest.guard';
import { CalendarWrapperComponent } from '../calendar/calendar-wrapper/calendar-wrapper/calendar-wrapper.component';
import { AuditGuard } from '../../components/audit-log/audit.guard';
import { WorkflowConfigComponent } from '../workflow/workflow-config/workflow-config.component';
import { WorkflowGuard } from '../workflow/workflow.guard';
import { EntityScreenComponent } from '../../components/entity-screen/entity-screen.component';
import { WorkflowKanbanWrapperComponent } from '../workflow/workflow-kanban-wrapper/workflow-kanban-wrapper.component';
import { ContactListGuard } from '../contact-list/contact-list.guard';
import { EmailDigestListComponent } from '../../components/email-digest/email-digest-list.component';
import { LoginUsageReportComponent } from '../../components/audit-log/usage-report/usage-report.component';
import { EntityAssociatedInfoComponent } from '../entity-list/entity-associated-info.component';
import { EntityAssociatedInfoGuard } from '../entity-list/entity-associated-info.guard';

const routes: Routes = [
    {
        path: '',
        component: HomeComponent,
        canActivate: [HomeGuard],
        children: [
            { path: 'research', redirectTo: 'home', pathMatch: 'full' },
            { path: 'research/:id', component: ResearchWrapperComponent },
            { path: 'research-emaildigest', component: ResearchWrapperComponent },
            { path: 'entities', component: EntityListComponent },
            { path: 'contacts', component: ContactListComponent, canDeactivate: [ContactListGuard] },
            { path: 'contact/:id', component: ContactComponent },
            { path: 'entity/:id', component: EntityScreenComponent },
            { path: 'entity/:id/associated-info', component: EntityAssociatedInfoComponent, canActivate: [EntityAssociatedInfoGuard] },
            { path: 'contact/:id/associated-info', component: EntityAssociatedInfoComponent, canActivate: [EntityAssociatedInfoGuard] },
            { path: 'entry/:id', component: ThreadViewComponent },
            { path: 'entry/:id/:sidenote', component: ThreadViewComponent },
            { path: 'event/:id', component: ThreadViewComponent },
            {
                path: 'feeds',
                loadChildren: () => import('../feeds/feeds.module').then(m => m.FeedsModule)
            },
            { path: 'auditlog', component: AuditLogComponent, canActivate: [AuditGuard] },
            { path: 'usagereport', component: LoginUsageReportComponent, canActivate: [AuditGuard] },
            {
                path: 'settings',
                loadChildren: () => import('../settings/settings.module').then(m => m.SettingsModule)
            },
            { path: 'home', component: HomeScreenComponent },
            { path: 'dashboard/:id', component: DashboardViewerWrapperComponent },
            { path: 'dashboard/create/:id', component: DashboardEditorComponent, canDeactivate: [DashboardGuard] },
            { path: 'dashboard/edit/:id', component: DashboardEditorComponent, canDeactivate: [DashboardGuard] },
            { path: 'dashboard/copy/:id', component: DashboardEditorComponent, canDeactivate: [DashboardGuard] },
            { path: 'dataimport', component: DataImportComponent, canDeactivate: [DataImportGuard] },
            { path: 'global_search', component: GlobalSearchComponent },
            { path: 'email-digest', component: EmailDigestListComponent },
            { path: 'email-digest/:id', component: EmailDigestEditorComponent, canDeactivate: [EmailDigestGuard] },
            { path: 'email-digest/copy/:id', component: EmailDigestEditorComponent, canDeactivate: [EmailDigestGuard] },
            { path: 'file', component: FileViewComponent }, // TODO will delete this when finished. Will add this back in 19.2.
            { path: 'calendar', component: CalendarWrapperComponent },
            { path: 'calendar/:id', component: CalendarWrapperComponent },
            { path: 'workflow/kanban/:screenid/:id', component: WorkflowKanbanWrapperComponent },
            { path: 'workflow/config/new', component: WorkflowConfigComponent, canDeactivate: [WorkflowGuard] },
            { path: 'workflow/config/draft/:id', component: WorkflowConfigComponent, canActivate: [WorkflowGuard], canDeactivate: [WorkflowGuard] },
            { path: 'workflow/config/edit', component: WorkflowConfigComponent, canActivate: [WorkflowGuard], canDeactivate: [WorkflowGuard] },
            { path: 'workflow/config/edit/:id', component: WorkflowConfigComponent, canActivate: [WorkflowGuard], canDeactivate: [WorkflowGuard] },
            { path: 'workflow/config/copy/:id', component: WorkflowConfigComponent, canActivate: [WorkflowGuard], canDeactivate: [WorkflowGuard] },
            { path: '', redirectTo: 'home', pathMatch: 'full' },
        ]
    },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class HomeRoutingModule { }
